import { render, staticRenderFns } from "./ReceivePackModal.vue?vue&type=template&id=4539f11c&"
import script from "./ReceivePackModal.vue?vue&type=script&lang=js&"
export * from "./ReceivePackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports